import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from './hooks/queryClient'
import { AnnouncerProvider } from './components/accessibility/LiveRegion'
import { AppRouter } from './app/router/AppRouter'
import { API_BASE } from './services/api'
import { BugReportWidget } from '@returned/shared-web'

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AnnouncerProvider>
        <Router>
          <AppRouter />
        </Router>
        <BugReportWidget
          apiBase={API_BASE}
          reportPath="/api/love/errors"
          screenshotPath="/api/love/errors/screenshot"
          rateKey="love_bug_report"
          userStorageKey="loveline_user"
        />
      </AnnouncerProvider>

      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} position="bottom" />}
    </QueryClientProvider>
  )
}

export default App
